import {useEffect,useState,type FormEvent} from 'react';
import {CircleAlert,Save,UserRound} from 'lucide-react';
import {saveOrdinarySharedProfile,type OrdinarySharedProfile} from '../lib/ordinarySharedProfile';
import './AccountProfile.css';

type Props={profile:OrdinarySharedProfile|null;loading:boolean;loadError?:string;onSaved:(profile:OrdinarySharedProfile)=>void};
export default function AccountProfile({profile,loading,loadError='',onSaved}:Props){
 const [username,setUsername]=useState('');
 const [displayName,setDisplayName]=useState('');
 const [saving,setSaving]=useState(false);
 const [error,setError]=useState('');
 const [notice,setNotice]=useState('');
 useEffect(()=>{setUsername(profile?.username||'');setDisplayName(profile?.displayName||'');setError('');setNotice('')},[profile?.accountId,profile?.username,profile?.displayName]);
 async function submit(e:FormEvent<HTMLFormElement>){
  e.preventDefault();
  if(saving||!profile)return;
  setError('');setNotice('');setSaving(true);
  try{
   const next=await saveOrdinarySharedProfile(username,displayName);
   onSaved(next);setNotice('Profile saved. Your name is updated in Agentordinary.');
  }catch(e){setError(e instanceof Error?e.message:'Unable to save profile.')}
  finally{setSaving(false)}
 }
 return <section className="panel ao-account-profile" aria-label="Account profile">
  <header className="ao-profile-heading"><UserRound size={24}/><div><h1>Profile</h1><p className="muted">Your account name and username.</p></div></header>
  {loadError&&<p className="message error" role="alert"><CircleAlert size={16}/>{loadError}</p>}
  {loading?<p>Loading your profile…</p>:!profile?<p>Sign in to view and edit your profile.</p>:
   <form onSubmit={submit}>
    <label htmlFor="ordinary-profile-display">Display name
     <input id="ordinary-profile-display" type="text" autoComplete="name" maxLength={80} value={displayName}
      onChange={e=>setDisplayName(e.target.value)} required placeholder="Your name"/>
    </label>
    <label htmlFor="ordinary-profile-username">Username
     <span className="ao-profile-input-with-prefix"><span aria-hidden="true">@</span>
      <input id="ordinary-profile-username" type="text" autoComplete="nickname" minLength={3} maxLength={30}
       pattern="[a-zA-Z][a-zA-Z0-9_]{2,29}" value={username}
       onChange={e=>setUsername(e.target.value.replace(/^@/,'').toLowerCase())} placeholder="Choose a username"/>
     </span>
    </label>
    <p className="muted">Your username is optional. Use 3–30 letters, numbers or underscores, beginning with a letter. Your sign-in email and password will not change.</p>
    {error&&<div className="message error" role="alert"><CircleAlert size={16}/>{error}</div>}
    {notice&&<p className="message success" role="status">{notice}</p>}
    <button className="primary-action" type="submit" disabled={saving||!displayName.trim()}>
     <Save size={17}/>{saving?'Saving…':'Save profile'}
    </button>
    <p className="muted ao-profile-scope">This is the Ordinary family shared-profile record. Other Ordinary sites will use it when they are connected to the same account service; separate logins are not linked automatically.</p>
   </form>}
 </section>;
}
